export default __webpack_public_path__ + "static/media/Tailwind Light.b36650ec.woff2";